import { render, staticRenderFns } from "./Cloud.vue?vue&type=template&id=2b0cfbc1&scoped=true&"
import script from "./Cloud.vue?vue&type=script&lang=js&"
export * from "./Cloud.vue?vue&type=script&lang=js&"
import style0 from "./Cloud.vue?vue&type=style&index=0&id=2b0cfbc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0cfbc1",
  null
  
)

export default component.exports